// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_POLICY } from "./action";

export function canDeletePolicy(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_POLICY);
}
